export const version = 'kunde-v1.17.0-rc1';